import { render, staticRenderFns } from "./ServicesTime.vue?vue&type=template&id=81af66e8&scoped=true&"
import script from "./ServicesTime.vue?vue&type=script&lang=js&"
export * from "./ServicesTime.vue?vue&type=script&lang=js&"
import style0 from "./ServicesTime.vue?vue&type=style&index=0&id=81af66e8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81af66e8",
  null
  
)

export default component.exports